















































import { Component, Vue } from 'vue-property-decorator';
import { IProxyError } from '@/interfaces';
import {
  readProxyErrors,
  dispatchGetProxyErrors,
  dispatchDeleteProxyErrors,
  dispatchDeleteProxyError,
} from '@/store/admin/accessors';

@Component
export default class ProxyErrors extends Vue {
  public search: string = '';

  public selected: IProxyError[] = [];
  public pagination: { rowsPerPage; footerProps } = {
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: 'Service',
      sortable: true,
      value: 'service_name',
      align: 'left',
    },
    {
      text: 'Status code',
      sortable: true,
      value: 'status_code',
      align: 'left',
    },
    {
      text: 'Error code',
      sortable: true,
      value: 'error_code',
      align: 'left',
    },
    {
      text: 'Type',
      sortable: true,
      value: 'type',
      align: 'left',
    },
    {
      text: 'Connection',
      sortable: true,
      value: 'conn',
      align: 'left',
    },
    {
      text: 'Description',
      value: 'error_description',
      align: 'left',
    },
    {
      text: 'User ban duration',
      value: 'user_ban_duration',
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'id',
    },
  ];
  get proxyErrors() {
    return readProxyErrors(this.$store);
  }

  public async mounted() {
    await dispatchGetProxyErrors(this.$store, { serviceId: null });
  }

  public async deleteProxyError(id: number) {
    if (confirm('Are you sure you want to delete this proxy error?')) {
      await dispatchDeleteProxyError(this.$store, id);
      await dispatchGetProxyErrors(this.$store, { serviceId: null });
    }
  }

  public async deleteProxyErrors() {
    if (confirm('Are you sure you want to delete selected proxy errors?')) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteProxyErrors(this.$store, selected);
      await dispatchGetProxyErrors(this.$store, { serviceId: null });
    }
  }
}
